export default __webpack_public_path__ + "static/media/next.1b2b52c0.svg";